import React from 'react';
import { PageHeader } from '../components/layout/PageHeader';
import { BoardEducationContent } from '../components/sections/BoardEducationContent';
export function BoardEducationPage() {
  return <div data-id="element-210" data-mp="29m24q7vv3p5n">
      <PageHeader eyebrow="Board Experience, Education & Civic Leadership" title="Governance, Academic Background & Community Contribution" data-id="element-211" data-mp="29maj647mv2iy" />
      <section className="bg-white pb-20 lg:pb-28" data-id="element-212" data-mp="329xwqzahksw3">
        <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-213" data-mp="32ag4as2lmtjb">
          <BoardEducationContent data-id="element-214" data-mp="379ixnf97vbbg" />
        </div>
      </section>
    </div>;
}